import { buildUrl, formatParam } from "../util/integration"

import { authorizedFetch } from "./http_api";

export const fetchCountriesAPI = (username, password) => {
    return fetch(buildUrl("country/all?username=" + formatParam(username) + "&password=" + formatParam(password)) , {method: "GET"})
}

export const fetchCategoriesAPI = (
    username,
    accessToken,
) => {
    return authorizedFetch(
        accessToken,
        buildUrl("category/all"),
        {
            method: "GET",
        },
    );
};